/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Die Werte EINER Bahn, aufgeloest ueber die Rollen der Zuordnung
 * (`minigolfBahnNummer`, `…Bezeichnung`, `…Norm`, `…Tipp`, `…Layout`,
 * `…Grafik`, `…AbschlagPosition`, `…AbschlagStunde`, `…AbschlagMinute`,
 * `…Ball1` bis `…Ball3`).
 * 
 * WAS NICHT ZUGEORDNET IST, FEHLT HIER — nicht als leerer Wert, sondern
 * gar nicht. Die Anzeige laesst den Block dann weg, statt einen leeren
 * Rahmen zu zeichnen.
 * @export
 * @interface MinigolfBahn
 */
export interface MinigolfBahn {
    /**
     * 
     * @type {string}
     * @memberof MinigolfBahn
     */
    entryId?: string;
    /**
     * 
     * @type {number}
     * @memberof MinigolfBahn
     */
    nummer?: number;
    /**
     * 
     * @type {string}
     * @memberof MinigolfBahn
     */
    bezeichnung?: string;
    /**
     * 
     * @type {number}
     * @memberof MinigolfBahn
     */
    norm?: number;
    /**
     * Spielweise und Laufhinweise.
     * @type {string}
     * @memberof MinigolfBahn
     */
    tipp?: string;
    /**
     * Form der Bahn, z. B. „gerade" oder „abknickend rechts".
     * @type {string}
     * @memberof MinigolfBahn
     */
    layout?: string;
    /**
     * Adresse der Bahngrafik, fertig zum Anzeigen. Leer, wenn keine
     * hinterlegt ist.
     * @type {string}
     * @memberof MinigolfBahn
     */
    grafik?: string;
    /**
     * 
     * @type {string}
     * @memberof MinigolfBahn
     */
    abschlagPosition?: string;
    /**
     * 
     * @type {number}
     * @memberof MinigolfBahn
     */
    abschlagStunde?: number;
    /**
     * 
     * @type {number}
     * @memberof MinigolfBahn
     */
    abschlagMinute?: number;
    /**
     * Ballempfehlungen in der Reihenfolge 1 bis 3, Leeres weggelassen.
     * @type {Array<string>}
     * @memberof MinigolfBahn
     */
    baelle?: Array<string>;
}

/**
 * Check if a given object implements the MinigolfBahn interface.
 */
export function instanceOfMinigolfBahn(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MinigolfBahnFromJSON(json: any): MinigolfBahn {
    return MinigolfBahnFromJSONTyped(json, false);
}

export function MinigolfBahnFromJSONTyped(json: any, ignoreDiscriminator: boolean): MinigolfBahn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entryId': !exists(json, 'entryId') ? undefined : json['entryId'],
        'nummer': !exists(json, 'nummer') ? undefined : json['nummer'],
        'bezeichnung': !exists(json, 'bezeichnung') ? undefined : json['bezeichnung'],
        'norm': !exists(json, 'norm') ? undefined : json['norm'],
        'tipp': !exists(json, 'tipp') ? undefined : json['tipp'],
        'layout': !exists(json, 'layout') ? undefined : json['layout'],
        'grafik': !exists(json, 'grafik') ? undefined : json['grafik'],
        'abschlagPosition': !exists(json, 'abschlagPosition') ? undefined : json['abschlagPosition'],
        'abschlagStunde': !exists(json, 'abschlagStunde') ? undefined : json['abschlagStunde'],
        'abschlagMinute': !exists(json, 'abschlagMinute') ? undefined : json['abschlagMinute'],
        'baelle': !exists(json, 'baelle') ? undefined : json['baelle'],
    };
}

export function MinigolfBahnToJSON(value?: MinigolfBahn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entryId': value.entryId,
        'nummer': value.nummer,
        'bezeichnung': value.bezeichnung,
        'norm': value.norm,
        'tipp': value.tipp,
        'layout': value.layout,
        'grafik': value.grafik,
        'abschlagPosition': value.abschlagPosition,
        'abschlagStunde': value.abschlagStunde,
        'abschlagMinute': value.abschlagMinute,
        'baelle': value.baelle,
    };
}

